import React, { useEffect, useState } from "react";
import { SearchIcon } from "../common/Icon";
import { createFollowUpPopUpData } from "../common/Helper";
import LogChatNotesModal from "./LogChatNotesModal";
import { useStateProvider } from "../common/StateProvider";

const LogChatProfileModal = () => {
  const [filteredList, setFilteredList] = useState(createFollowUpPopUpData);
  const [inputFilter, setInputFilter] = useState("");
  // const [setActiveCard] = useState(null);
  const { logChatNotesModal, setLogChatNotesModal } = useStateProvider(); //Log Chat Notes Modal

  const inputChangeHandler = (value) => {
    const filteredData = createFollowUpPopUpData.filter((obj) => {
      return obj.createFollowUpNameText
        .toLowerCase()
        .includes(value.toLowerCase());
    });
    setFilteredList(filteredData);
    setInputFilter(value);
    // setActiveCard(null); // Clear the active card when typing in the input
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (logChatNotesModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [logChatNotesModal]);
  return (
    <>
      <div className="rounded-xl border-[(1px_solid_rgba(111,_106,_248,_0.10))] bg-white shadow-todays_workflow_box_shadow pt-[18px]  relative w-[320px] xs:w-[375px] xm:w-[440px]">
        <div className="flex gap-2 border border-solid border-[#929292] ps-4 py-2  items-center rounded-[50px] mx-4">
          <span className=" opacity-60">
            <SearchIcon />
          </span>
          <input
            className="ff_poppins font-normal text-[14px] text-black placeholder:text-black placeholder:opacity-70 bg-transparent placeholder:font-normal pe-[10px] outline-none w-11/12"
            type="text"
            value={inputFilter}
            onChange={(e) => inputChangeHandler(e.target.value)}
          />
        </div>
        <div className=" overflow-y-auto h-[320px] overflow_x_scroll_style">
          {filteredList.map((data, index) => {
            return (
              <div
                onClick={() => setLogChatNotesModal(true)}
                className="flex items-center justify-between mt-[12px] hover:shadow-workflow_item_card_shadow duration-200 py-[12px] px-[10px] rounded-[6px] cursor-pointer mx-4 mb-[18px]"
                key={index}>
                <div className="flex items-center">
                  <img
                    className="w-[30px] h-[30px]"
                    src={data.createFollowUpImg}
                    alt="profile"
                  />
                  <p className="mb-0 ms-[11px] font-normal text-[14px] text-black">
                    {data.createFollowUpNameText}
                  </p>
                </div>
                {/* <span className="profile_calander group">{data.svgIcon}</span> */}
              </div>
            );
          })}
        </div>
        <div className=" absolute top-[-15px] right-0 z-[9999999999]">
          {logChatNotesModal && (
            <LogChatNotesModal setLogChatNotesModal={setLogChatNotesModal} />
          )}
        </div>
      </div>
    </>
  );
};

export default LogChatProfileModal;
